import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { Chip } from 'primereact/chip';
import { useState, useEffect, useRef } from 'react';
import FormCrearProductoFicha from './FormCrearProductoFicha';
import { Steps } from "primereact/steps";
import { useGlobalContext } from "../Config";

const FormCrearProducto = ({
    displayDialog,
    setDisplayDialog,
    producto,
    setProducto,
    tipoProductoOptions,
    handleCreateProducto,
    baseUrl,
    empresa,
    nombreEmpresa,
    loading3
}) => {
    const [activeStep, setActiveStep] = useState(0);
    const stepsItems = [{ label: "Producto", command: () => setActiveStep(0) },{ label: "Ficha técnica", command: () => setActiveStep(1) },];
    const handleStepChange = (e) => {setActiveStep(e.index);};
    const [productos, setProductos] = useState([]);
    const [productosFiltrados, setProductosFiltrados] = useState([]);
    const [loading2, setLoading2] = useState(false);
    const fichaRef = useRef(null);
    const [perfil, setPerfil] = useState("");
    const [ficha, setFicha] = useState("");
    const { headerText } = useGlobalContext();
    const fetchData = async () => {
        try {
            if (empresa) {
                setLoading2(true);
                const fetchProductos = async () => {
                    try {
                        const response = await fetch(
                            `${baseUrl}getProductosByEmpresa?empresa=${nombreEmpresa}`
                        );
                        const data = await response.json();
                        setProductos(data.productos);
                        setLoading2(false);
                    } catch (error) {
                        console.error("Error fetching productos:", error);
                        setLoading2(false);
                    }
                };
                fetchProductos();
            }
        } catch (error) {
            console.error("Error al obtener los productos:", error);
        }
    };

    const filtrarProductosPorTipo = (tipoProducto) => {
        if (!tipoProducto) {
            setProductosFiltrados([]);
            return;
        }

        const productosFiltrados = productos.filter(producto => {
            // Comparar el tipoProducto string con la descripción del tipo seleccionado
            const productoTipo = producto.tipoProducto; // String como 'SITIO', 'MINI PYME'
            const tipoSeleccionado = tipoProducto.descripcion; // String como 'CONTAINER'
            
            // Comparar los strings directamente (removido el filtro de activo que causaba el problema)
            return productoTipo === tipoSeleccionado;
        });
        
        setProductosFiltrados(productosFiltrados);
    };

    useEffect(() => {
        if (displayDialog && empresa) {
            fetchData();
        }
    }, [displayDialog, empresa]);

    useEffect(() => {
        if (producto.tipoProducto) {
            filtrarProductosPorTipo(producto.tipoProducto);
        } else {
            setProductosFiltrados([]);
        }
    }, [producto.tipoProducto, productos]);

    const limpiarFormulario = () => {
        setProducto({ 
            descripcion: "", 
            metraje: "", 
            tipoProducto: "", 
            productosAdyacentes: [] 
        });
        setDisplayDialog(false);
    };

    const removerProductoAdyacente = (index) => {
        const productosActualizados = producto.productosAdyacentes.filter((_, i) => i !== index);
        setProducto({ ...producto, productosAdyacentes: productosActualizados });
    };

    // Función para manejar la creación del producto
    const handleCrearProducto = async () => {
        try {
            // Llamar a la función original de crear producto
            const resultado = await handleCreateProducto();
            if (resultado && resultado.producto && resultado.producto.id) {
                const idProducto = resultado.producto.id;
                // Llamar a la función para crear la ficha técnica con el ID del producto
                await handleCrearProductoFicha(idProducto);
                // Cerrar el diálogo después de crear el producto y la ficha técnica
                setDisplayDialog(false);
            }
        } catch (error) {
            console.error("Error al crear producto:", error);
        }
    };

    const handleCrearProductoFicha = async (idProducto) => {
        try {
            // Obtener los datos del componente FormCrearProductoFicha a través de la referencia
            if (fichaRef.current) {
                const fichaData = fichaRef.current.getData();
                
                const body = {
                    idProducto: idProducto,
                    perfil: fichaData.perfil,
                    ficha: fichaData.fichaJson
                };
    
                const resp = await fetch(`${baseUrl}/createProductoFicha`, {
                    method: "POST",
                    headers: { 
                        "Content-Type": "application/json; charset=UTF-8"
                    },
                    body: JSON.stringify(body),
                });
                
                return resp.ok;
            }
        } catch (error) {
            console.error("Error al crear ficha técnica:", error);
            return false;
        }
    };

    const footerCrearProd = () => {
        return (
            <div className="p-d-flex p-jc-end p-mt-3">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={limpiarFormulario}
                    className="p-button p-mr-2 p-button-outlined p-button-rounded p-button"
                    raised
                />
                <Button
                    label="Guardar"
                    icon={loading3 ? "pi pi-spin pi-spinner" : "pi pi-save"}
                    onClick={handleCrearProducto}
                    className="p-button-success p-button-rounded p-button"
                    raised
                    autoFocus
                    disabled={loading3 || !producto.descripcion || !producto.metraje || !producto.tipoProducto}
                />
            </div>
        );
    };

    return (
        <div className="form-container">
            <Dialog
                visible={displayDialog}
                onHide={limpiarFormulario}
                className="p-fluid product-dialog"
                footer={footerCrearProd()}
                header={"Crear Producto"}
            >
                <Steps 
                    model={stepsItems} 
                    activeIndex={activeStep} 
                    onSelect={handleStepChange}
                    className="cursor-pointer"
                    style={{ cursor: 'pointer' }}
                    readOnly={false}
                />
                
                {activeStep === 0 && (
                    <div className="card">
                        <h6 className="mb-3">
                            Información del Producto
                        </h6>
                        {/* Tipo de Producto */}
                        <span className="p-float-label mt-2 mb-3">
                            <Dropdown
                                id="tipoProducto"
                                value={producto.tipoProducto}
                                options={tipoProductoOptions}
                                onChange={(e) => {
                                    setProducto({ 
                                        ...producto, 
                                        tipoProducto: e.value,
                                        productosAdyacentes: [] // Limpiar productos adyacentes al cambiar tipo
                                    });
                                }}
                                optionLabel="descripcion"
                                placeholder="Seleccione el tipo de producto"
                                required
                            />
                            <label htmlFor="tipoProducto">
                                <i className="pi pi-tag mr-2"></i>Tipo de Producto *
                            </label>
                        </span>
                        
                        {/* Descripción del Producto */}
                        <span className="p-float-label mt-2 mb-3">
                            <InputText
                                id="descripcion"
                                value={producto.descripcion}
                                onChange={(e) =>
                                    setProducto({
                                        ...producto,
                                        descripcion: e.target.value.toUpperCase(),
                                    })
                                }
                                className="p-inputtext-lg"
                                placeholder="Ingrese la descripción del producto"
                                required
                                max={35}
                            />
                            <label htmlFor="descripcion">
                                <i className="pi pi-file-edit mr-2"></i>Descripción *
                            </label>
                        </span>

                        {/* Metraje del Producto */}
                        <span className="p-float-label mt-2 mb-3">
                            <InputNumber
                                id="metraje"
                                value={producto.metraje === "" ? null : producto.metraje}
                                onValueChange={(e) => setProducto({ ...producto, metraje: e.value })}
                                className="p-inputtext-lg"
                                placeholder="Ingrese el metraje del producto"
                                required
                                min={0}
                                max={10000}
                                locale="es-ES"
                                inputMode="numeric"
                                step={1}
                                minFractionDigits={0}
                                maxFractionDigits={0}
                                allowEmpty
                            />
                            <label htmlFor="metraje"><i className="pi pi-th-large mr-1"></i>Metraje del Producto (m²) *</label>
                        </span>

                        {/* Sección de Productos Adyacentes */}
                        {producto.tipoProducto && (
                            <div className="mt-4 mb-3">
                                <h6 className="mb-3">
                                    <i className="pi pi-tags mr-2"></i>
                                    Productos Adyacentes
                                </h6>
                                <p className="text-sm text-muted mb-3">
                                    Seleccione los productos de tipo <strong>{producto.tipoProducto.descripcion}</strong> que estarán adyacentes a este nuevo producto.
                                </p>
                                
                                <span className="p-float-label">
                                    <MultiSelect
                                        id="productosAdyacentes"
                                        value={producto.productosAdyacentes || []}
                                        options={productosFiltrados.filter(p => 
                                            !producto.productosAdyacentes?.some(selected => selected.id === p.id)
                                        )}
                                        onChange={(e) => setProducto({ ...producto, productosAdyacentes: e.value })}
                                        optionLabel="descripcion"
                                        selectedItemTemplate={(option) => {
                                            return option ? `${option.descripcion}; ` : '';
                                        }}
                                        itemTemplate={(option) => {
                                            return (
                                                <div>
                                                    <span>{option.descripcion}</span>
                                                    <span style={{ marginLeft: '10px', color: '#6c757d', fontSize: '0.9em' }}>
                                                        ({option.metraje} m²)
                                                    </span>
                                                </div>
                                            );
                                        }}
                                        maxSelectedLabels={3}
                                        className="w-full"
                                        placeholder={loading2 ? "Cargando productos..." : "Seleccione productos adyacentes"}
                                        disabled={productosFiltrados.length === 0 || loading2}
                                        filter
                                        showClear
                                    />

                                    <label htmlFor="productosAdyacentes">
                                        {loading2 ? (
                                            <>
                                                <i className="pi pi-spin pi-spinner mr-1"></i>Cargando productos...
                                            </>
                                        ) : (
                                            <>
                                                <i className="pi pi-tags mr-2"></i>Productos Adyacentes
                                            </>
                                        )}
                                    </label>
                                </span>
                                
                                {productosFiltrados.length === 0 && producto.tipoProducto && (
                                    <small className="text-orange-500 mt-1 block">
                                        <i className="pi pi-info-circle mr-1"></i>
                                        No hay productos de tipo {producto.tipoProducto.descripcion.toLowerCase()} disponibles para asignar como adyacentes.
                                    </small>
                                )}
                                
                                {/* Lista de productos adyacentes seleccionados */}
                                {producto.productosAdyacentes && producto.productosAdyacentes.length > 0 && (
                                    <div className="mt-3">
                                        <small className="text-muted block mb-2">
                                            <i className="pi pi-check-circle mr-1"></i>
                                            Productos adyacentes seleccionados ({producto.productosAdyacentes.length}):
                                        </small>
                                        <div className="flex flex-wrap gap-2">
                                            {producto.productosAdyacentes.map((prod, index) => (
                                                <Chip 
                                                    key={`${prod.id}-${index}`}
                                                    label={`${prod.descripcion} (${prod.metraje}m²)`}
                                                    className="p-mr-2 p-mb-2"
                                                    removable
                                                    onRemove={() => removerProductoAdyacente(index)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {/* Navegación entre steps */}
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button label="" rounded outlined icon="pi pi-arrow-right" iconPos="right" className="" onClick={() => setActiveStep(1)}/>
                        </div>
                    </div>
                )}
                {activeStep === 1 && (
                    <div className="card">
                        <FormCrearProductoFicha
                            ref={fichaRef}
                            perfil={perfil}
                            ficha={ficha}
                        />
                        <div className="flex-space-between">
                            <Button label="" icon="pi pi-arrow-left" rounded outlined onClick={() => setActiveStep(0)} />
                        </div>
                    </div>
                )}
            </Dialog>
        </div>
    );
};

export default FormCrearProducto;
